export enum TransactionSpeed {
  LOW = 'low',
  MIDDLE = 'middle',
  HIGH = 'high',
}
